import { Facebook, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "@/i18n/LanguageContext";
import { SITE_URL } from "@/lib/site-url";
import { trackLandingEvent } from "@/lib/landingAnalytics";

export type ShareChannel = "whatsapp" | "facebook" | "copy_link";

/** Botones discretos para compartir una landing/herramienta: WhatsApp, Facebook y copiar enlace. */
export default function LandingShareButtons({ path, text, slug }: { path: string; text: string; slug?: string }) {
  const { t, lang } = useLanguage();
  const url = `${SITE_URL}${path}`;
  const enc = encodeURIComponent;
  const btn = "inline-flex h-11 w-11 items-center justify-center rounded-full border border-border bg-card text-foreground transition-colors hover:bg-secondary";
  // Registra el canal (nunca texto del usuario). Además el mapa de clics los registra como clic normal (otro tipo de evento, no se suman).
  const track = (channel: ShareChannel) => {
    if (!slug) return;
    void trackLandingEvent({ landingSlug: slug, eventType: "share_click", lang, metadata: { channel } }, { skipGa: true });
  };
  const copy = async () => {
    track("copy_link");
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("shareLanding", "copied"));
    } catch {
      toast.error(t("shareLanding", "copyError"));
    }
  };
  return (
    <div className="mt-3 flex items-center justify-center gap-2" data-rl-share="1">
      <span className="text-xs text-muted-foreground">{t("shareLanding", "label")}</span>
      <a className={btn} onClick={() => track("whatsapp")} href={`https://wa.me/?text=${enc(`${text} ${url}`)}`} target="_blank" rel="noopener noreferrer" aria-label={t("shareLanding", "whatsapp")} data-rl-click="Compartir WhatsApp">
        <MessageCircle className="h-5 w-5" strokeWidth={1.5} />
      </a>
      <a className={btn} onClick={() => track("facebook")} href={`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`} target="_blank" rel="noopener noreferrer" aria-label={t("shareLanding", "facebook")} data-rl-click="Compartir Facebook">
        <Facebook className="h-5 w-5" strokeWidth={1.5} />
      </a>
      <button type="button" className={btn} onClick={() => void copy()} aria-label={t("shareLanding", "copy")} data-rl-click="Copiar enlace">
        <Link2 className="h-5 w-5" strokeWidth={1.5} />
      </button>
    </div>
  );
}
